import I18n from 'components/I18n'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import { YapilyInstitution } from 'data/Payments/BankTransfer/types'
import messages from 'lang'
import React, { useState } from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

import { Header, ModalTitle } from '../../styles'
import Institution from './Institution'

type Props = {
  institutions: YapilyInstitution[]
  onBack: () => void
  onSelect: (YapilyInstitution) => void
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

const ListItem = styled.li`
  display: flex;
  cursor: pointer;
  padding: 1rem;
  border: 0;
  border-top: 1px solid ${color('grey500')};

  :hover {
    background: ${color('grey700')};
  }

  :last-child {
    border-bottom: 1px solid ${color('grey500')};
  }
`

const StyledInstitution = styled(Institution)`
  flex: 1;
`

const SearchBox = styled.input`
  width: 100%;
  padding: 1.25rem;
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
  outline: none;
  background: ${color('dark800')};
  color: ${color('white')};
  border-radius: 8px;
  border: 1px solid ${color('dark800')};

  :focus {
    border: 1px solid ${color('primary')};
  }
  :hover {
    background: ${color('grey700')};
  }
`

const SelectInstitution = ({ institutions, onBack, onSelect }: Props) => {
  const [search, setSearch] = useState<string>('')
  const displayedInstitutions = institutions.filter(
    (institution) => institution.name.toLowerCase().indexOf(search.toLowerCase()) > -1
  )
  return (
    <>
      <Header>
        <Arrow onClick={onBack} side={ArrowSide.LEFT} />
        <ModalTitle>
          <I18n data={messages.link_bank_select_bank_title} />
        </ModalTitle>
      </Header>
      <main>
        <SearchBox
          onChange={(e) => setSearch(e.target.value)}
          placeholder='Search'
          type='text'
          value={search}
        />
        <List>
          {displayedInstitutions.map((institution) => (
            <ListItem key={institution.id}>
              <StyledInstitution institution={institution} onClick={onSelect} />
              <Arrow side={ArrowSide.RIGHT} />
            </ListItem>
          ))}
        </List>
      </main>
    </>
  )
}

export default SelectInstitution
